import { render } from "./TagEdit.vue?vue&type=template&id=28450b76&scoped=true&ts=true"
import script from "./TagEdit.vue?vue&type=script&lang=ts"
export * from "./TagEdit.vue?vue&type=script&lang=ts"

import "./TagEdit.vue?vue&type=style&index=0&id=28450b76&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28450b76"]])

export default __exports__